import {Box, Container, Flex, HStack, IconButton, Link, Text, Tooltip} from "@chakra-ui/react";
import {useEffect, useState} from "react";
import {FiBookOpen} from "react-icons/fi";
import {AdapterContext, ConnectionContext} from "./Contexts";
import {DeviceState} from "./components/DeviceState";
import {TabsPage} from "./Tabs";

function PixelMark() {
  const pixels = [
    "#ffd84d", "#ffd84d", null, "#5ed5c8",
    "#ffd84d", null, "#ff7a68", "#5ed5c8",
    "#ffd84d", "#ff7a68", "#ff7a68", null,
    null, "#ff7a68", "#5ed5c8", "#5ed5c8",
  ];
  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(4, 5px)"
      gridTemplateRows="repeat(4, 5px)"
      gap="2px"
      p="8px"
      bg="#111315"
      border="1px solid"
      borderColor="whiteAlpha.200"
      borderRadius="5px"
      aria-hidden="true"
    >
      {pixels.map((color, index) => (
        <Box
          key={index}
          width="5px"
          height="5px"
          borderRadius="1px"
          bg={color ?? "#292c30"}
          boxShadow={color ? `0 0 5px ${color}66` : "none"}
        />
      ))}
    </Box>
  );
}

function App({adapter}) {
  const [connected, setConnected] = useState(adapter.connected);

  useEffect(() => {
    const unsubscribeConnection = adapter.onConnectionChange((value) => {
      setConnected(Boolean(value));
    });
    return unsubscribeConnection;
  }, [adapter]);

  return (
    <ConnectionContext.Provider value={connected}>
      <AdapterContext.Provider value={adapter}>
        <Box minH="100vh" bg="#08090a" color="#f2f3f4">
          <Box
            as="header"
            position="sticky"
            top={0}
            zIndex="sticky"
            borderBottom="1px solid"
            borderColor="#25282c"
            bg="rgba(9, 10, 11, .96)"
            backdropFilter="blur(14px)"
          >
            <Container maxW="1600px" px={{base: 4, md: 6}}>
              <Flex
                minH={{base: "68px", md: "76px"}}
                py={2}
                align="center"
                justify="space-between"
                gap={{base: 3, md: 6}}
                wrap="wrap"
              >
                <HStack spacing={3} flexShrink={0}>
                  <PixelMark />
                  <Box>
                    <Text as="h1" fontSize={{base: "md", md: "lg"}} lineHeight="1.1" fontWeight="800">WebSGuai</Text>
                    <Text color="#757b84" fontSize="10px" textTransform="uppercase" fontWeight="700">Display studio</Text>
                  </Box>
                </HStack>
                <HStack spacing={{base: 1, md: 3}} minW={0}>
                  <Tooltip label="Documentation" hasArrow>
                    <IconButton
                      as={Link}
                      href="https://github.com/iebb/WebSGuai/tree/master/docs"
                      isExternal
                      aria-label="Documentation"
                      icon={<FiBookOpen />}
                      variant="ghost"
                      size="sm"
                      borderRadius="5px"
                      color="#8c929b"
                      display={{base: "none", sm: "inline-flex"}}
                    />
                  </Tooltip>
                  <DeviceState />
                </HStack>
              </Flex>
            </Container>
          </Box>

          {!connected && (
            <Box borderBottom="1px solid" borderColor="#2a2d31" bg="#111214">
              <Container maxW="1600px" px={{base: 4, md: 6}} py="7px">
                <Flex align="center" justify="space-between" gap={3} wrap="wrap">
                  <HStack spacing={2}>
                    <Box width="6px" height="6px" bg="#ffb45e" borderRadius="full" />
                    <Text fontSize="11px" color="#c7c9cc" fontWeight="600">Offline workspace</Text>
                  </HStack>
                  <Text fontSize="10px" color="#6f747c">Drafts save locally</Text>
                </Flex>
              </Container>
            </Box>
          )}

          <Container as="main" maxW="1600px" px={{base: 0, md: 6}}>
            <TabsPage />
          </Container>
        </Box>
      </AdapterContext.Provider>
    </ConnectionContext.Provider>
  );
}

export default App;
